(() => {
  const init = (root) => {
    if (!root || root.dataset.meDesignsReady === 'true') return;
    root.dataset.meDesignsReady = 'true';

    const search = root.querySelector('[data-me-design-search]');
    const cards = [...root.querySelectorAll('[data-me-design-card]')];
    const count = root.querySelector('[data-me-design-count]');
    const empty = root.querySelector('[data-me-design-empty]');

    const apply = () => {
      const term = (search?.value || '').trim().toLowerCase();
      let visible = 0;
      cards.forEach((card) => {
        const haystack = (card.dataset.search || '').toLowerCase();
        const show = !term || haystack.includes(term);
        card.hidden = !show;
        if (show) visible += 1;
      });
      if (count) count.textContent = `${visible} design${visible === 1 ? '' : 's'}`;
      if (empty) empty.hidden = visible !== 0;
    };

    search?.addEventListener('input', apply);
    apply();
  };

  document.querySelectorAll('[data-me-designs-catalog]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-me-designs-catalog]').forEach(init);
  });
})();
